var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Current Users")]),_c('ul',{attrs:{"id":"current-users"}},_vm._l((_vm.getUsers),function(current,index){return _c('li',{key:index},[_vm._v(_vm._s(current))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }